import * as React from 'react'

import { Box, Text, Touchable, useToggle } from '@factorialco/deprecated-design-system'

import type { VariableItem } from 'modules/automations/components/Show/SendCustomNotification/Selects/BodyVariables/variables'

interface ItemProps {
  item: VariableItem
  onSelect: (variable: string, isCustomTag: boolean) => void
}

const Item = ({ item, onSelect }: ItemProps) => {
  const [isHovering, toggleHovering] = useToggle(false)
  const textColor = isHovering ? 'viridian1000' : 'grey800'
  const text = item.label().toLowerCase()

  return (
    <Touchable onClick={() => onSelect(item.payloadVariable, !!item.isCustomTag)}>
      <Box background="grey100" paddingY="s8" paddingLeft="s32" paddingRight="s16" flexGrow>
        <div onMouseEnter={toggleHovering(true)} onMouseLeave={toggleHovering(false)}>
          <Text size="300" color={textColor} weight="medium">
            {text}
          </Text>
        </div>
      </Box>
    </Touchable>
  )
}

export default Item
